import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { StepService } from '../../services/step.service';
import { defaultTabs } from '../../shared/tabs';
// import { defaultTabs, defaultTabsFlowB } from '../../shared/tabs';
// TODO: flowb
import { takeUntil, Subject } from 'rxjs';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit {

  tabs!: any[];

  state!: string;

  step!: number;

  templateSuffix = environment.templateSuffix;

  destroy: Subject<boolean> = new Subject<boolean>();

  constructor(public stepService: StepService) { }

  ngOnInit(): void {
    // TODO: flowb
    // this.tabs = this.stepService.isFlow('A') ? defaultTabs : defaultTabsFlowB;
    this.tabs = defaultTabs;
    this.stepService.state.pipe(takeUntil(this.destroy)).subscribe((resp) => {
      
      this.state = resp;
      this.getClass();
    });
  }

  showIfMyStep(step: number){
    return this.step === step ? true : false;
  }

  showIfNotMyStep(step:number){
    return this.step > step ? true : false;
  }

  getClass() {
    this.step = this.tabs.findIndex((tab) => tab.states.includes(this.state));
    this.stepService.tabNumber.next(this.step + 1);
  }

}
